<div class="modal-content">
  <div class="modal-header">
    <p *ngIf="!selectedStatTypeID" class="modal-title font-16 mb-0 text-dark">
      <span>{{ 'company_employee_policies.modal_title_add_policy_to_employee' | translate }}</span>
    </p>
    <p *ngIf="selectedStatTypeID" class="modal-title font-16 mb-0 text-dark">
      <span>{{ 'company_employee_policies.modal_title_add_policy_adjustment_to_employee' | translate }}</span>
    </p>
    
    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
        type="button"
    >
        <span
            aria-hidden="true"
            class="font-24 text-muted"
        >
          <i class="mdi mdi-close"></i>
        </span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <form
                (ngSubmit)="onSubmit()"
                [formGroup]="addPolicyToEmployeeForm"
                autocomplete="off"
            >
              <div *ngIf="!selectedStatTypeID" class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="control-label required-label">{{ 'company_employee_policies.policies' | translate }}</label>
                      <a class="btn btn-link p-0 mb-2"
                         routerLink="/setting/attendance"
                         type="button">{{ 'company_employee_policies.action_create' | translate }}
                      </a>
                    </div>
                    
                    <ng-select (change)="onPolicyChange($event)"
                               [clearable]="false"
                               [items]="companyPolicies"
                               [placeholder]="'company_employee_policies.select_policy' | translate"
                               bindLabel="name"
                               bindValue="company_employee_policy_ID"
                               class="custom"
                               formControlName="company_employee_policy_ID"
                               name="company_employee_policy_ID"
                    ></ng-select>
                    
                    <div *ngIf="submitted && f.company_employee_policy_ID.errors">
                      <p
                          *ngIf="f.company_employee_policy_ID.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'company_employee_policies.policies' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div *ngIf="employeePresetPolicy || employeeSetPolicy" class="row mb-2">
                <div class="col-12">
                  <p>
                    <span>{{ 'company_employee_policies.settings' | translate }}: </span>
                    <a routerLink="/setting/attendance">{{ employeePresetPolicy?.name ?? employeeSetPolicy?.name }} {{ employeePresetPolicy?.label ?? employeeSetPolicy?.label }}</a>
                  </p>
                </div>
                <div *ngIf="employeePresetPolicy" class="col-12 text-right">
                  <small class="text-muted">
                    {{ 'company_employee_policies.settings_description' | translate }}
                  </small>
                </div>
              </div>
              
              <div *ngIf="employeeSetPolicy || selectedStatTypeID" class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span *ngIf="selectedStatTypeID">{{ 'employees.start_date' | translate }}</span>
                      <span *ngIf="!selectedStatTypeID">{{ 'employees.onboarding_date' | translate }}</span>
                    </label>
                    <input
                        (flatpickrClose)="fpHelper.applyAltInputValue($event, false); onDateChange($event)"
                        [allowInput]="true"
                        [altInput]="true"
                        [disableMobile]="true"
                        [locale]="locale$ | async"
                        [minDate]="effectiveFromMinDate"
                        altFormat="d.m.Y"
                        class="form-control"
                        dateFormat="Y-m-d"
                        formControlName="effective_from" mwlFlatpickr
                        name="effective_from"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.effective_from.errors">
                      <p *ngIf="f.effective_from.errors.required" class="text-danger validation-text">
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'employees.days_in_company' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <hr>
              
              <h4 *ngIf="employeeDatetimeTypes?.controls?.length > 0">{{ 'company_employee_policies.datetimes_adjustment_title' | translate }}</h4>
              <div *ngIf="employeeDatetimeTypes?.controls?.length > 0" class="row">
                <div class="col-12 text-right">
                  <small class="text-muted">
                    {{ 'company_employee_policies.datetimes_adjustment_description' | translate }}
                  </small>
                </div>
              </div>
              <ng-container formArrayName="employee_datetime_types">
                <div *ngFor="let datetimeTypesForm of employeeDatetimeTypes?.controls; let index = index" [formGroupName]="index" class="row">
                  <div class="col-12 mt-2">
                    <label class="control-label required-label">{{ datetimeTypesForm.value?.name }} - {{ "company_employee_policies.hours" | translate }} </label>
                    <input
                        class="form-control"
                        formControlName="hours"
                        name="hours"
                        type="number"
                    >
                    
                    <div *ngIf="submitted && datetimeTypesForm.get('hours').errors">
                      <p *ngIf="datetimeTypesForm.get('hours').errors.required" class="text-danger validation-text">
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'company_employee_policies.hours' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>
              
              <div class="row mt-3">
                <div class="col-12 text-right">
                  <button class="btn btn-success"
                          type="submit"
                  >{{ 'employees.action_save' | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
